/**
 * Farm & Acre Co - POH Mount Guard
 *
 * Bar/chain combo products have a "POH mount" variant that ONLY fits specific Husqvarna
 * models, plus "Standard mount" variants that fit most saws. Customers were picking POH by
 * mistake. This adds two safety layers (the helper line above the picker is server-rendered):
 *   1. A caution box + card highlight while a POH option is selected.
 *   2. A hard-stop confirm modal when Add-to-Cart is pressed with POH selected.
 *
 * Product-agnostic: keys off the word "POH" in the selected variant's visible text, so it
 * works for 2-option and 3-option combos regardless of order/wording. Touches no pricing,
 * inventory, SKU or cart logic — only gates the add with a confirmation.
 */

(function () {
  'use strict';

  function isPohLabel(radio) {
    var label = radio && radio.closest('label.farm-spotlight__variant-option');
    return !!(label && /POH/i.test(label.textContent || ''));
  }

  function init() {
    var radios = document.querySelectorAll('input[data-variant-radio]');
    if (!radios.length) return;

    // Only engage if this product actually has a POH option.
    var hasPoh = Array.prototype.some.call(radios, isPohLabel);
    if (!hasPoh) return;

    // Standard-first default: the picker renders the Standard variant checked, but the product's
    // selected_or_first_available_variant (and thus the hidden input[name="id"]) may still seed a
    // POH variant if Shopify ordered it first. Fire a change on the checked (Standard) radio so the
    // inline radio-sync handler writes Standard's id into the hidden input — otherwise a no-touch
    // Add-to-Cart adds POH.
    var checkedRadio = document.querySelector('input[data-variant-radio]:checked');
    if (checkedRadio) checkedRadio.dispatchEvent(new Event('change', { bubbles: true }));

    var caution = document.querySelector('.poh-caution');
    var modal = document.querySelector('.poh-modal');
    var confirmed = false;

    function selectedRadio() {
      return document.querySelector('input[data-variant-radio]:checked');
    }

    function pohSelected() {
      var sel = selectedRadio();
      return !!(sel && isPohLabel(sel));
    }

    function refresh() {
      var isPoh = pohSelected();
      if (caution) caution.hidden = !isPoh;
      document.querySelectorAll('label.farm-spotlight__variant-option').forEach(function (label) {
        var r = label.querySelector('input[data-variant-radio]');
        label.classList.toggle('is-poh-selected', !!(r && r.checked && /POH/i.test(label.textContent || '')));
      });
      confirmed = false; // any selection change re-arms the confirm gate
    }

    radios.forEach(function (r) { r.addEventListener('change', refresh); });
    refresh();

    // Hard stop: intercept Add-to-Cart submit (capture) when POH is selected.
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || form.tagName !== 'FORM') return;
      var isAddForm = (form.getAttribute('action') || '').indexOf('/cart/add') > -1 ||
                      !!form.querySelector('button[name="add"]');
      if (!isAddForm) return;
      if (!pohSelected() || confirmed || !modal) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      openModal(form);
    }, true);

    function openModal(form) {
      modal.hidden = false;
      modal.dataset.formId = (form && form.id) || '';
      document.documentElement.classList.add('poh-modal-open');
      var confirmBtn = modal.querySelector('[data-poh-confirm]');
      if (confirmBtn) confirmBtn.focus();
    }

    function closeModal() {
      if (!modal) return;
      modal.hidden = true;
      document.documentElement.classList.remove('poh-modal-open');
    }

    if (modal) {
      modal.addEventListener('click', function (e) {
        if (e.target.closest('[data-poh-confirm]')) {
          confirmed = true;
          closeModal();
          // Re-submit through the normal flow (now allowed because confirmed === true).
          var form = (modal.dataset.formId && document.getElementById(modal.dataset.formId)) ||
                     document.querySelector('form[action*="/cart/add"]');
          var addBtn = form && form.querySelector('button[name="add"], [type="submit"]');
          if (addBtn) addBtn.click();
        } else if (e.target.closest('[data-poh-cancel]')) {
          closeModal();
        }
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !modal.hidden) closeModal();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
